import Form from '../components/Form';
import 'form-serializer';
import 'jquery-validation';

class ZipLocation extends Form {
  setupDefaults() {
    super.setupDefaults();

    this.endpoint = this.$el.attr('action');

    this.dom = {
      ...this.dom,
      $toggleBtn: this.$el.find('.zip-locator__toggle'),
      $submitBtn: this.$el.find('.js-zip-location-submit'),
      $changeLocation: this.$el.find('.zip-locator__change-location'),
      $inputField: this.$el.find('.zip-locator__form-field'),
      $changeLocationField: this.$el.find('.zip-locator__change-location .zip-locator__form-field')
    };
  }

  addListeners() {
    this.$el.on('submit', ::this.onZipSubmit);
    this.dom.$toggleBtn.on('click', ::this.onZipToggle);
    this.dom.$submitBtn.on('click', ::this.onZipSubmit);
    this.dom.$changeLocationField.on('focus', ::this.displayChangeLocationForm);
  }

  displayChangeLocationForm(e) {
    e.preventDefault();
    this.dom.$changeLocation.addClass('zip-locator__change-location--opened');
  }

  onZipToggle(e) {
    this.$el.parent().toggleClass('zip-locator--open');

    if (this.$el.parent().hasClass('zip-locator--open')) {
      this.dom.$inputField.attr('tabindex', 0);
      this.dom.$submitBtn.attr('tabindex', 0);
      this.dom.$inputField.focus();
    } else {
      this.dom.$inputField.attr('tabindex', -1);
      this.dom.$submitBtn.attr('tabindex', -1);
    }
  }

  onZipSubmit(e) {
    e.stopPropagation();
    e.preventDefault();
    if (this.$el.valid()) {
      this.submitZip().catch(err => {
        console.log('Server error: ', err);
      });
    }
  }

  async submitZip() {
    const res = await this.postZip()

    if (res.success) {
      const redirectURL = res.response.redirectUrl;
      window.location.replace(redirectURL);
    } else {
      //Error handling here
      this.clearFormLevelError();
      this.displayFormLevelError(res.message);
    }
  }

  postZip() {
    const data = this.$el.serializeJSON();
    return $.ajax({
      method: 'POST',
      url: this.endpoint,
      contentType: 'application/json',
      data
    })
  }
}

export default ZipLocation;



// WEBPACK FOOTER //
// ./src/tc/js/components/ZipLocation.js